module.exports = __webpack_public_path__ + "static/media/logoCompany_old.73c67be2.svg";